import apiClient from './apiClient';

export interface SportRef {
  id: string;
  label: string;
  identifier: string;
}

export interface ThemeRef {
  id: string;
  label: string;
  identifier: string;
}

export interface FormatRef {
  id: string;
  label: string;
  identifier: string;
  /** v7: unique across race types (Tri_S vs Du_S); what the admin grids display. */
  slug: string;
  raceTypeId: number;
}

export interface RaceTypeRef {
  id: number;
  label: string;
  identifier: string;
}

export const getSports = async (): Promise<SportRef[]> => {
  const response = await apiClient.get('admin/reference/sports');
  return response.data as SportRef[];
};

export const getThemesRef = async (): Promise<ThemeRef[]> => {
  const response = await apiClient.get('admin/reference/themes');
  return response.data as ThemeRef[];
};

export const getFormats = async (): Promise<FormatRef[]> => {
  const response = await apiClient.get('admin/reference/formats');
  return response.data as FormatRef[];
};

export const getRaceTypes = async (): Promise<RaceTypeRef[]> => {
  const response = await apiClient.get('admin/reference/race-types');
  return response.data as RaceTypeRef[];
};
